export function restaurantSettingsDTO(data) {
  if (data) {
    return {
      id: data?.id || '',
      currency: data?.currency || '',
      currencySign: data?.currencySign || '',
      vat: data?.vat || '',
    }
  }
}